import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Prompt, withRouter } from 'react-router-dom';
import classNames from 'classnames';
import { Tabs, Tab, TabList, TabPanel } from 'react-tabs';
import { List } from 'immutable';
import Button, { SolidButton } from 'components/Button';
import SVG from 'components/base/SVG';
import { campaignPath, dialerPath } from 'app/routes';
import { selectTags, selectStatuses } from 'data/property';
import { selectCampaign, selectLoading, selectDialerCampaignDetails, MarketingCampaignStatuses, loadDialerCampaignDetails, selectDialerCampaignLeads, loadDialerCampaignLeads } from 'data/campaigns';
import Loader from 'components/Loader';
import EndDialerCampaignConfirmationModal from "../../AccountNew/modals/EndDialerCampaignConfirmationModal";
import { checkSkipTraced, checkSkipTracedGroup } from 'data/contacts/actions';
import SkipTracePanel from './SkipTracePanel';
import SkipTraceButton from './SkipTraceButton';
import SkipTraceHandler from 'app/components/SkipTraceHandler';
import ProgressBar from "components/ProgressBar";
import noSkipTracedImage from 'assets/images/no-skip-traced-numbers.svg';
import css from './style.scss';
import css2 from '../style.scss';
import { duplicateDialerCampaign, updateDialerCampaign, getCallCountForToday } from 'data/user/actions';
import { ContactAssignmentPopup } from 'app/components/GroupAssignment';
import { downloadDialerCampaignReport, endDialerCampaign } from '../../../data/campaigns/actions';
import CampaignDetails from "./CampaignDetails";
import CurrentLeadContactCard from './CurrentLeads';
import CurrentLeadPreview from './InvestorLeadCard/CurrentLeadPreview';
import CommonNotes from "../Dialer/ManageNotes"
import Select from '../../../components/Select';
import MultiSelect from '../../../components/MultiSelect';
import { resetNotesDirty, setNotesDirty } from '../../../data/campaigns/actions';
import { selectNotesDirty } from '../../../data/campaigns/selectors';
import NotesNotSaved from '../../AccountNew/modals/NotesNotSaved';
import cssModal from "../../../app/AccountNew/style.scss";
import { selectDocuments, selectPropertyStatus } from '../../../data/property/selectors';
import { validate, verify, verifyRequiref } from 'utils/validation';
import { deletePropertyDocument, downloadPropertyDocument, loadPropertyDocuments, savePropertyStatus, uploadPropertyDocument } from '../../../data/property/actions';
import ToastNotification from '../../components/ToastNotification';
import ClickToDial from '../../../components/ClickToDial';
import { selectUserProfile, selectProfile, selectCallCountForToday, selectCallCountForTodayLoading } from "data/user/selectors";
import { getContactIds } from 'data/contacts';

import { Map } from 'immutable';
import { getProperty, getPropertyStatus, getPropertyContact } from 'data/property/actions';
import PropertyInfo from '../../components/Map/PropertyInfo';
import Confirm from 'app/components/Confirm';
import MangePropertyTagModal from '../../components/MangePropertyTagModal';
import InfoAlert from '../../components/InfoAlert';
import ConfirmationModal from 'app/AccountNew/modals/ConfirmationModal';
import CallProgress from '../../components/CallProgress';
import { MAX_DAILY_CALLS } from '../../../data/user/constants';

class DialerCampaign extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSettingsClick = this.handleSettingsClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleDownloadClick = this.handleDownloadClick.bind(this);
    this.handleDuplicateClick = this.handleDuplicateClick.bind(this);
    this.handleEndCampaignClick = this.handleEndCampaignClick.bind(this);
    this.handleEditLeadsClick = this.handleEditLeadsClick.bind(this);
    this.handleSkipTraceClick = this.handleSkipTraceClick.bind(this);
    this.handleTabSelect = this.handleTabSelect.bind(this);
    this.onLeadsTableScroll = this.onLeadsTableScroll.bind(this);
    this.handleTagsSelect = this.handleTagsSelect.bind(this);

    this.leadsTableRef = React.createRef();

    this.state = {
      selectedTabIndex: 0,
      isSkipTraced: true, // TODO: Replace with actual skip trace check - set to true for shell to show tabs
      skipTracedContacts: [],
      nonSkipTracedContacts: [],
      checkingSkipTrace: false,
      hasCheckedSkipTrace: false, // NEW: Track if we've already checked
      headerSkipTraceContactIds: null,
      headerStartSkipTrace: false,
      showRenameModal: false,
      editName: '',
      displayName: null,
      isDuplicating: false,
      showEndCampaignModal: false,
      isEndingCampaign: false,
      dialerCampaignId: 0,
      isDownloading: false,
      currentLeadIndex: 0,
      isLoadingProperty: false,
      notes: "",
      attachments: [],
      selectedStatus: null,
      selectedTags: [],
      initialNotes: "",
      initialAttachments: [],
      isNotesDirty: false,
      showNotesModal: false,
      pendingNavigation: null,
      nextLocation: null,
      id: null,
      showToast: false,
      toastMessage: "",
      toastType: "success", // or 'error'
      isSavingNotesCard: false,
      showRemoveModal: false,
      removeAttachmentIndex: null,
      lastRequestedPropertyId: null,
      showCallProgress: false
    };
  }

  navigationInProgress = false;

  componentWillMount() {
    // TODO: Check if list is skip traced
    // For now, we'll assume it's skip traced to show tabs
    // this.checkSkipTraceStatus();

    // Load dialer campaign details
    // Load dialer campaign leads

    let { location, loadDialerCampaignDetails, loadDialerCampaignLeads } = this.props;
    const regex = /campaign\/(\d+)(?:\/dialer\/(\d+))?/;
    const matches = location.pathname.match(regex);
    const dialerId = matches && matches.length > 1 ? matches[2] : null
    const dialerCampaignId = dialerId ? Number(dialerId) : null;

    if (dialerCampaignId) {
      loadDialerCampaignDetails(dialerCampaignId);
      loadDialerCampaignLeads(dialerCampaignId, this.props.leadsTableLimit, 1);
      this.props.getCallCountForToday();
      this.setState({ dialerCampaignId, currentLeadIndex: 0 });
    }
  }

  handleClickOutside = (event) => {
    if (this.popupRef && !this.popupRef.contains(event.target)) {
      this.setState({ showCallProgress: false });
    }
  };

  componentDidMount() {
    const { campaign, match, history } = this.props;
    const { checkingSkipTrace, currentLeadIndex } = this.state;
    const { dialerCampaignId } = match.params;
    document.addEventListener("mousedown", this.handleClickOutside);
    if (campaign?.get('id') && !checkingSkipTrace) {
      this.checkSkipTraceStatus();
    }

    window.addEventListener("beforeunload", this.handleBeforeUnload);
  }

  componentDidUpdate(prevProps, prevState) {
    const { campaign, dialerCampaignLeads, dialerCampaignDetails } = this.props;
    const { checkingSkipTrace, selectedTabIndex, currentLeadIndex, hasCheckedSkipTrace } = this.state;
    const prevCampaign = prevProps.campaign;


    // Detect when the dialer campaign ID changes in the URL
    if (prevProps.location.pathname !== location.pathname) {
      const regex = /campaign\/(\d+)(?:\/dialer\/(\d+))?/;
      const matches = location.pathname.match(regex);
      const dialerId = matches && matches.length > 1 ? matches[2] : null;
      const newDialerCampaignId = dialerId ? Number(dialerId) : null;

      if (newDialerCampaignId && newDialerCampaignId !== this.state.dialerCampaignId) {
        // Reset state but DON'T load data yet
        this.setState({
          dialerCampaignId: newDialerCampaignId,
          currentLeadIndex: 0,
          hasCheckedSkipTrace: false,
          selectedTabIndex: 0,
          isSkipTraced: null, // Set to null to indicate we don't know yet
          skipTracedContacts: [],
          nonSkipTracedContacts: [],
          checkingSkipTrace: false,

          currentSavedPropertyId: null
        }, () => {
          this.props.loadDialerCampaignDetails(newDialerCampaignId);
          this.props.getCallCountForToday();
        });
        return;
      }
    }

    // Check if we need to run skip trace check and load data
    const campaignIdChanged = campaign?.id && (!prevCampaign?.id || campaign.id !== prevCampaign.id);
    const dialerDetailsChanged = dialerCampaignDetails && dialerCampaignDetails !== prevProps.dialerCampaignDetails;
    const contactIdsChanged = campaign?.get('contactIds') && prevCampaign?.get('contactIds') &&
      campaign.get('contactIds') !== prevCampaign.get('contactIds');

    if (!checkingSkipTrace && !hasCheckedSkipTrace && (campaignIdChanged || dialerDetailsChanged || contactIdsChanged)) {
      this.checkSkipTraceStatus();
    }

    if (prevState.checkingSkipTrace && !this.state.checkingSkipTrace && this.state.hasCheckedSkipTrace) {
      this.props.loadDialerCampaignLeads(this.state.dialerCampaignId, this.props.leadsTableLimit, 1);
    }

    if (
      prevProps.dialerCampaignLeads !== this.props.dialerCampaignLeads &&
      this.props.dialerCampaignLeads?.leads?.length &&
      this.props.dialerCampaignLeads?.page === 1 &&
      this.state.currentLeadIndex === 0
    ) {
      const lead = this.props.dialerCampaignLeads?.leads?.[0];

      this.setState({
        currentPropertyId: lead.propertyInfo?.propertyId || null,
      });
    }

    // It handles the valid scrolling movements between the leads on the Current Leads Tab
    // Also it handles the case, when we are going to the next/previous page: we are changing the currentLeadIndex, and after it the current page
    //    It processes the movement only once, and it loads the property, the status and the documents only once
    if ((prevState.currentLeadIndex == currentLeadIndex - 1)
      || (prevState.currentLeadIndex == currentLeadIndex + 1)
      || (prevProps.dialerCampaignLeads?.page == this.props.dialerCampaignLeads?.page + 1 && currentLeadIndex == this.props.dialerCampaignLeads?.leads?.length - 1)
      || (prevProps.dialerCampaignLeads?.page == this.props.dialerCampaignLeads?.page - 1 && currentLeadIndex == 0)
      || (prevProps.dialerCampaignLeads?.totalPages == this.props.dialerCampaignLeads?.totalPages + 1)
    ) {
      if (this.props.dialerCampaignLeads?.leads?.length && this.props.dialerCampaignLeads?.leads?.length > currentLeadIndex) {
        const currentPropertyId = this.props.dialerCampaignLeads.leads[currentLeadIndex]?.propertyInfo?.propertyId;
        const currentSavedPropertyId = this.props.dialerCampaignLeads.leads[currentLeadIndex]?.propertyInfo?.savedPropertyId;
        this.setState({ currentPropertyId, currentSavedPropertyId });
      }
    }

    if (
      this.state.currentPropertyId &&
      prevState.currentPropertyId !== this.state.currentPropertyId &&
      this.props.dialerCampaignLeads?.leads?.[this.state.currentLeadIndex]
    ) {
      const freshLead =
        this.props.dialerCampaignLeads.leads[this.state.currentLeadIndex];
      const freshPropertyId = freshLead?.propertyInfo?.propertyId ?? null;
      const freshSavedPropertyId = freshLead?.propertyInfo?.savedPropertyId ?? null;

      if (freshPropertyId !== this.state.currentPropertyId) return;

      this.props.getPropertyStatus(this.state.currentPropertyId);
      this.props.getPropertyContact(this.state.currentPropertyId);
      this.loadCurrentLeadProperty(this.state.currentPropertyId, () => {
        if (freshSavedPropertyId) {
          this.props.loadPropertyDocuments(freshSavedPropertyId);
        }
      });
    }

    if (this.props.propertyStatus !== prevProps.propertyStatus) {
      const response = this.props.propertyStatus ? this.props.propertyStatus.toJS() : null;

      this.setState({
        selectedStatus: response?.statusId ?? null,
        selectedTags: response?.assignedTags ?? [],
        notes: response?.note ?? '',
        id: this.state.currentPropertyId,
      });
    }

    if (prevProps.documents != this.props.documents) {
      const attachments = this.props.documents?.map(doc => ({
        name: doc.get('name'),
        file: doc.get('previewUrl') || doc.get('url'),
        id: doc.get('id'),
      })).toJS();

      this.setState({ attachments });
    }
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.handleBeforeUnload);
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  handleBeforeUnload = (e) => {
    if (this.props.notesDirty) {
      e.preventDefault();
      e.returnValue = ""; // required for Chrome
    }
  };

  loadCurrentLeadProperty = (propertyId, onSuccess) => {
    console.log('Loading property for ID:', propertyId);

    if (!propertyId) {
      console.log('No property ID found');
      return;
    }

    this.lastRequestedPropertyId = propertyId;
    this.setState({ isLoadingProperty: true });

    this.props.getProperty(propertyId, 'M')
      .then(() => {
        console.log('Property loaded successfully');
        if (this.lastRequestedPropertyId !== propertyId) return;
        this.setState({ isLoadingProperty: false });
        onSuccess && onSuccess();
      })
      .catch(error => {
        console.error('Error loading property:', error);
        this.setState({ isLoadingProperty: false });
        onSuccess && onSuccess();
      });
  }

  onLeadsTableScroll(event) {
    let { loadDialerCampaignLeads } = this.props;

    const distanceToBottomOfTable = Math.abs(event.target.scrollHeight - event.target.clientHeight - event.target.scrollTop);
    let bottomOfTable = event.target.scrollHeight - event.target.clientHeight;

    if (event.target.scrollTop != undefined && event.target.scrollTop == 0 && bottomOfTable > 0 && this.props.dialerCampaignLeads.page > 1) {
      loadDialerCampaignLeads(this.state.dialerCampaignId, this.props.leadsTableLimit, this.props.dialerCampaignLeads.page - 1);

      if (this.props.dialerCampaignLeads.page == this.props.dialerCampaignLeads.totalPages) {
        bottomOfTable = window.dialerCampaignContactsTableScrollTopMax;
      }

      event.target.scrollTo({ top: bottomOfTable - 1, left: 0, behavior: "smooth" });
    }
    else if (distanceToBottomOfTable < 1 && this.props.dialerCampaignLeads.page < this.props.dialerCampaignLeads.totalPages) {
      let isAppend = false;

      // We append the remaining Leads to the current page, to keep the scrolling ability, and to be able to page backwards on the last page
      if (this.props.dialerCampaignLeads.page + 1 == this.props.dialerCampaignLeads.totalPages
        && this.props.dialerCampaignLeads.totalLeads < (this.props.leadsTableLimit * this.props.dialerCampaignLeads.totalPages)) {
        isAppend = true;
      }

      loadDialerCampaignLeads(this.state.dialerCampaignId, this.props.leadsTableLimit, this.props.dialerCampaignLeads.page + 1, isAppend);

      if (!isAppend) {
        event.target.scrollTo({ top: 1, left: 0, behavior: "smooth" });
      }

      window.dialerCampaignContactsTableScrollTopMax = bottomOfTable;
    }
  }

  checkSkipTraceStatus = () => {
    const { campaign, checkSkipTraced } = this.props;
    const { checkingSkipTrace, hasCheckedSkipTrace } = this.state;

    // Prevent multiple calls - exit early if already checking or already checked
    if (!campaign || !campaign.get('id') || checkingSkipTrace || hasCheckedSkipTrace) {
      return;
    }

    const contactIds = campaign.get('contactIds');
    const contactIdsArray = List.isList(contactIds) ? contactIds.toJS() : (Array.isArray(contactIds) ? contactIds : []);

    if (!contactIds || (List.isList(contactIds) && contactIds.isEmpty()) || (Array.isArray(contactIds) && contactIds.length === 0) || contactIdsArray.length === 0) {
      this.setState({
        isSkipTraced: false,
        skipTracedContacts: [],
        nonSkipTracedContacts: [],
        checkingSkipTrace: false,
        hasCheckedSkipTrace: true, // Mark as checked
      });
      return;
    }

    this.setState({ checkingSkipTrace: true });

    checkSkipTraced(
      { contactIds: contactIdsArray },
      ({ response, error }) => {
        if (error) {
          console.error('Error checking skip trace status:', error);
          this.setState({
            isSkipTraced: null,
            checkingSkipTrace: false,
            hasCheckedSkipTrace: true, // Mark as checked even on error
          });
          return;
        }

        const { skipTracedContacts = [], nonSkipTracedContacts = [] } = response || {};
        const hasNonSkipTraced = nonSkipTracedContacts && nonSkipTracedContacts.length > 0;

        this.setState({
          isSkipTraced: !hasNonSkipTraced,
          skipTracedContacts: skipTracedContacts || [],
          nonSkipTracedContacts: nonSkipTracedContacts || [],
          checkingSkipTrace: false,
          hasCheckedSkipTrace: true, // Mark as checked
        });
      }
    );
  }

  navigateWithGuard = (nextLocation) => {
    const { notesDirty, history } = this.props;

    if (!notesDirty) {
      history.push(nextLocation.pathname);
      return;
    }

    this.setState({
      showNotesModal: true,
      nextLocation,
    });
  };

  fetchPropertyStatus = (propertyId) => {
    console.log(propertyId, "propertyId");
    this.props.getPropertyStatus(propertyId, (response) => {
      console.log("API response:", response);
      this.setState({
        selectedStatus: response?.statusId ?? null,
        selectedTags: response?.assignedTags ?? [],
        notes: response?.note ?? "",
      });
    });
  };

  handleCallProgressClick = (e) => {
    e.stopPropagation();
    this.setState(prev => ({
      showCallProgress: !prev.showCallProgress
    }));
  };
  handleSettingsClick() {
    const { dialerCampaignDetails } = this.props;

    const campaignName =
      this.state.displayName ||
      dialerCampaignDetails?.name ||
      '';

    this.setState({
      showRenameModal: true,
      editName: campaignName,
    });
  }

  handleNameChange = (e) => {
    this.setState({ editName: e.target.value });
  };

  handleCancelName = () => {
    this.setState({ showRenameModal: false, name: null });
  };

  handleSaveName = () => {
    const { editName, dialerCampaignId } = this.state;
    const { updateDialerCampaign, location } = this.props;

    if (!editName || !editName.trim()) return;

    const dialerItem = location.state?.dialerItem;

    updateDialerCampaign(dialerCampaignId, editName.trim())
      .then((response) => {
        this.setState({
          showRenameModal: false,
          displayName: response.name,
          editName: ''
        });
        this.props.loadDialerCampaignDetails(dialerCampaignId);
      });

  };

  handleClose = () => {
    const { campaign } = this.props;

    this.setState({
      currentPropertyId: null,
      currentSavedPropertyId: null,
      lastRequestedPropertyId: null,
    }, () => {
      this.navigateWithGuard({
        pathname: campaignPath(campaign.get("id")),
      });
    });
  };

  handleDownloadClick = async () => {
    const { dialerCampaignId, isDownloading } = this.state;
    const { downloadDialerCampaignReport } = this.props;

    if (isDownloading) return;

    this.setState({ isDownloading: true });
    console.log(`Generating report for ${dialerCampaignId}`);

    downloadDialerCampaignReport(dialerCampaignId)
      .then(res => {
        if (res) {
          console.log('Report Download complete');
        }
      })
      .finally(() => {
        this.setState({ isDownloading: false });
      });
  }

  handleDuplicateClick() {
    const { location, history, duplicateDialerCampaign } = this.props;
    const { isDuplicating } = this.state;

    if (isDuplicating) return;

    const pathParts = location.pathname.split('/').filter(Boolean);
    const campaignId = pathParts[pathParts.indexOf('campaign') + 1];
    const dialerCampaignId = pathParts[pathParts.indexOf('dialer') + 1];

    if (!campaignId || !dialerCampaignId) return;

    this.setState({ isDuplicating: true });

    duplicateDialerCampaign(dialerCampaignId)
      .then(res => {
        if (res?.id) {
          history.push(`/campaign/${campaignId}/dialer/${res.id}`);
          this.setState({ displayName: res.name });
        }
      })
      .finally(() => {
        this.setState({ isDuplicating: false });
      });
  }

  handleEndCampaignClick() {
    this.setState({ showEndCampaignModal: true });
  }

  handleEndCampaignConfirmation = () => {
    const { isEndingCampaign } = this.state;
    const { location: { pathname }, endDialerCampaign, history } = this.props;

    const campaignsPath = pathname.split('/');
    const campaignId = campaignsPath[campaignsPath.indexOf('campaign') + 1];
    const dialerCampaignId = campaignsPath[campaignsPath.length - 1];

    if (isEndingCampaign) return;

    this.setState({ isEndingCampaign: true });

    endDialerCampaign(dialerCampaignId)
      .then(res => {
        if (res) {
          console.log('Dialer Campaign ended successfully');
        }
      })
      .finally(() => {
        this.setState({ showEndCampaignModal: false, isEndingCampaign: false });
        history.push(`/campaign/${campaignId}`); // reload campaign state
      });
  }

  handleCloseEndCampaignModal = () => {
    this.setState({ showEndCampaignModal: false });
  };

  handleEditLeadsClick() {
    const { openContactAssignmentPopup, dialerCampaignDetails, loadDialerCampaignDetails } = this.props;
    const status = dialerCampaignDetails?.status || MarketingCampaignStatuses.PROCESSING;

    const contactGroupId = dialerCampaignDetails?.contactGroupId;
    if (!contactGroupId) return;

    this.setState({ isLoadingContactIds: true });

    // 'C' marks the ContactGroupType as Contact, in the endpoint
    this.props.getContactIds("C" + contactGroupId, ({ response }) => {
      this.setState({ isLoadingContactIds: false });

      const contactIds = response;

      // View-only mode for CANCELLED (inactive) campaigns — matches postcard's immutable pattern
      const isViewOnly = status === "CANCELLED";

      openContactAssignmentPopup({
        ids: contactIds,
        viewMode: isViewOnly,
        ...(!isViewOnly && {
          onSave: (updatedContactIds) => {
            const { updateDialerCampaign, loadDialerCampaignLeads } = this.props;
            const { dialerCampaignId } = this.state;
            const dialerItem = this.props.location.state?.dialerItem;
            const campaignName = dialerItem?.get?.('name') || this.state.displayName || "New Dialer Campaign";

            updateDialerCampaign(dialerCampaignId, campaignName, updatedContactIds)
              .then(() => {
                loadDialerCampaignDetails(dialerCampaignId);
                loadDialerCampaignLeads(dialerCampaignId, this.props.leadsTableLimit, 1);
                // Reset skip trace check flag when leads are updated
                this.setState({ hasCheckedSkipTrace: false, currentLeadIndex: 0 });
              });
          },
        })
      });
    }, (error) => {
      this.setState({ isLoadingContactIds: false });

      if (error) {
        console.error('Error while getting the contact Ids for contact group Id:', error);
      }
    });
  }

  handleSkipTraceClick = () => {
    const { dialerCampaignDetails, checkSkipTracedGroup } = this.props;
    const contactGroupId = dialerCampaignDetails?.contactGroupId;

    if (!contactGroupId) {
      console.error('No contactGroupId found in dialerCampaignDetails');
      return;
    }

    checkSkipTracedGroup(
      contactGroupId,
      ({ response, error }) => {
        if (error) {
          console.error('Error checking skip trace group status:', error);
          return;
        }

        const { nonSkipTracedContacts = [] } = response || {};

        this.setState({
          headerSkipTraceContactIds: nonSkipTracedContacts,
          headerStartSkipTrace: true,
        });
      }
    );
  }

  handleHeaderSkipTraceComplete = () => {
    this.setState({
      headerSkipTraceContactIds: null,
      headerStartSkipTrace: false,
      hasCheckedSkipTrace: false, // Reset to allow re-checking
    });
    // Re-check skip trace status after completion
    setTimeout(() => {
      this.checkSkipTraceStatus();
    }, 1000);
  }

  handleTabSelect(index) {
    this.setState({ selectedTabIndex: index });
  }

  formatPhoneNumber(phoneNumber) {
    phoneNumber = phoneNumber.startsWith("+1") ? phoneNumber.substring(2, phoneNumber.length) : phoneNumber;

    if (phoneNumber.length < 10) {
      return phoneNumber;
    }

    return `(${phoneNumber.substring(0, 3)}) ${phoneNumber.substring(3, 6)}-${phoneNumber.substring(6, phoneNumber.length)}`;
  }

  getAddressText(lead) {
    let addressText = "";
    if (lead.contactInfo?.streetAddress) {
      addressText += lead.contactInfo?.streetAddress + "\n";
    }
    if (lead.contactInfo?.city) {
      addressText += lead.contactInfo?.city;
    }
    if (lead.contactInfo?.state || lead.contactInfo?.zip) {
      addressText += ", ";
      if (lead.contactInfo?.state) {
        addressText += lead.contactInfo?.state;
      }
      if (lead.contactInfo?.zip) {
        addressText += " " + lead.contactInfo?.zip;
      }
    }
    return addressText;
  }

  handlePreviousContact = () => {
    const { dialerCampaignLeads, loadDialerCampaignLeads } = this.props;
    const { currentLeadIndex } = this.state;

    if (currentLeadIndex > 0) {
      this.setState({ currentLeadIndex: currentLeadIndex - 1 });
    }
    else if (currentLeadIndex == 0 && dialerCampaignLeads.page > 1) {
      loadDialerCampaignLeads(this.state.dialerCampaignId, this.props.leadsTableLimit, dialerCampaignLeads.page - 1);
      this.setState({ currentLeadIndex: this.props.leadsTableLimit - 1 });
    }
  }

  handleNextContact = () => {
    const { dialerCampaignLeads, loadDialerCampaignLeads } = this.props;
    const { currentLeadIndex } = this.state;

    if (currentLeadIndex + 1 == dialerCampaignLeads.pageSize && dialerCampaignLeads.page + 1 <= dialerCampaignLeads.totalPages) {
      let nextLeadIndex = 0;
      let isAppend = false;

      // Same pagination logic for the last page of Leads
      // We append the remaining Leads to the current page, to keep the scrolling ability, and to be able to page backwards on the last page
      if (this.props.dialerCampaignLeads.page + 1 == this.props.dialerCampaignLeads.totalPages
        && this.props.dialerCampaignLeads.totalLeads < (this.props.leadsTableLimit * this.props.dialerCampaignLeads.totalPages)) {
        isAppend = true;
        nextLeadIndex = currentLeadIndex + 1;
      }

      loadDialerCampaignLeads(this.state.dialerCampaignId, this.props.leadsTableLimit, this.props.dialerCampaignLeads.page + 1, isAppend);
      this.setState({ currentLeadIndex: nextLeadIndex });
    }
    else {
      this.setState({ currentLeadIndex: currentLeadIndex + 1 });
    }
  }

  handleNotesChange = (html) => {
    this.setState({ notes: html });
    this.props.setNotesDirty(true);
  };

  handleFileUpload = ({ value: { file } }) => {
    if (!file) return;
    const { uploadPropertyDocument, dialerCampaignLeads } = this.props;

    const currentLead = dialerCampaignLeads?.leads?.[this.state.currentLeadIndex];
    const currentPropertyId = currentLead?.propertyInfo?.savedPropertyId ?? null;

    if (!currentPropertyId) {
      console.warn('currentPropertyId not found');
      return;
    }

    this.setState({ isNotesDirty: true });

    const formData = new FormData();
    formData.append('file', file);
    formData.append(
      'name',
      file.name.replace(/\.[^/.]+$/, '')
    );
    formData.append('description', '');
    uploadPropertyDocument(currentPropertyId, formData);
  };

  handleSave = (navigateAfterSave = false, source = "notes") => {
    const { savePropertyStatus, setNotesDirty, dialerCampaignLeads, history } = this.props;
    const { notes, selectedStatus, selectedTags, nextLocation, currentLeadIndex } = this.state;
    const currentPropertyId = dialerCampaignLeads?.leads.length ?
      dialerCampaignLeads.leads[currentLeadIndex].propertyInfo?.propertyId : null;
    this.setState({ isSavingNotesCard: true });
    validate(() => {
      const plainTextLength = notes.replace(/<[^>]*>/g, '').trim().length;
      if (plainTextLength > 4000) {
        this.props.showAlert({
          title: 'Invalid Note Length',
          infoText: 'Note length cannot exceed 4000 characters.',
        });
        this.setState({ isSavingNotesCard: false });
        return;
      }
      savePropertyStatus(
        currentPropertyId,
        {
          note: notes,
          statusId: selectedStatus,
          assignedTags: selectedTags,
        },
        () => {
          this.setState({ isSavingNotesCard: false });
          if (source === "notes") {
            this.showToast("Your notes have been saved successfully");
            setNotesDirty(false);
          }
          if (navigateAfterSave && nextLocation) {
            setTimeout(() => {
              if (this.unblock) {
                this.unblock();
                this.unblock = null;
              }
              this.setState(
                {
                  showNotesModal: false,
                  nextLocation: null,
                },
                () => {
                  history.push(nextLocation.pathname);
                }
              );
            }, 800);
          }
        }
      );
    });
  };

  handleCancelNavigation = () => {
    const { nextLocation } = this.state;
    const { history, setNotesDirty } = this.props;

    if (!nextLocation || this.navigationInProgress) return;

    this.navigationInProgress = true;

    // Discard changes
    setNotesDirty(false);

    // Fully unblock BEFORE navigating
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }

    this.setState(
      {
        showNotesModal: false,
        nextLocation: null,
      },
      () => {
        setTimeout(() => {
          history.push(nextLocation.pathname);
          this.navigationInProgress = false;
        }, 0);
      }
    );
  };

  handleConfirmNavigation = () => {
    if (this.navigationInProgress) return;

    this.navigationInProgress = true;
    this.handleSave(true);
  };

  handleDownloadAttachment = (attachment) => {
    if (!attachment?.id) return;

    this.props.downloadPropertyDocument(attachment.id);
  };

  showToast = (message, type = "success") => {
    this.setState({
      toastMessage: message,
      toastType: type,
      showToast: true,
    });

    setTimeout(() => {
      this.setState({ showToast: false });
    }, 3000);
  };

  parseLog(log) {
    const match = log.match(/^(.*?)\s*\((\d{2}\/\d{2}\/\d{4})\s-\s(.+)\)$/);

    if (!match) {
      return {
        event: log,
        date: '',
        user: '',
      };
    }

    return {
      event: match[1],
      date: match[2],
      user: match[3],
    };
  }

  handleRemoveAttachment = (index) => {
    this.setState({
      showRemoveModal: true,
      removeAttachmentIndex: index,
    });
  };

  handleCancelRemove = () => {
    this.setState({
      showRemoveModal: false,
      removeAttachmentIndex: null,
    });
  };

  handleConfirmRemove = () => {
    const { removeAttachmentIndex, attachments } = this.state;

    const attachment = attachments[removeAttachmentIndex];
    if (!attachment?.id) return;

    this.props.deletePropertyDocument(attachment.id);

    this.setState(prev => ({
      attachments: prev.attachments.filter(
        (_, i) => i !== removeAttachmentIndex
      ),
      showRemoveModal: false,
      removeAttachmentIndex: null,
    }));
  };

  handleStatusSelect = (item) => {
    if (item?.value === "") {
      return
    }

    this.setState(
      { selectedStatus: item?.value || null },
      () => {
        this.handleSave(false, "autosave");
      }
    );
  };

  handleTagsSelect = (ids) => {
    this.setState(
      { selectedTags: ids.filter(id => this.props.propertyTags?.map(tag => tag.id).includes(id)) },
      () => {
        this.handleSave(false, "autosave");
      }
    );
  };

  openMangePropertyTagModal = () => {
    const { MangePropertyTagModalOpen } = this.props;
    MangePropertyTagModalOpen();
  };

  render() {
    const { campaign, loading, dialerCampaignDetails, dialerCampaignLeads, property, propertyLoading, history } = this.props;
    const { propertyTags, propertyStatuses } = this.props;
    const { selectedTabIndex, isSkipTraced, nonSkipTracedContacts, showEndCampaignModal, isEndingCampaign, isDownloading, headerStartSkipTrace, headerSkipTraceContactIds, currentLeadIndex, isLoadingProperty, dialerCampaignId, checkingSkipTrace } = this.state;

    if (!campaign || !campaign.get('id')) {
      return null;
    }

    const campaignName = campaign.get('name') || 'Dialer Campaign';
    let isActive = campaign.get('active') !== false;
    const { location: { pathname } } = this.props;
    const campaignsPath = pathname.split('/');
    const marketingCampaignId = campaignsPath[campaignsPath.indexOf('campaign') + 1];
    // const dialerCampaignId = campaignsPath[campaignsPath.indexOf('dialer') + 1];

    const contactIds = campaign.get('contactIds');
    const contactIdsArray = contactIds ? (List.isList(contactIds) ? contactIds.toJS() : (Array.isArray(contactIds) ? contactIds : [])) : [];

    // Calculate leads summary from API response
    const status = dialerCampaignDetails?.status || MarketingCampaignStatuses.PROCESSING;
    const totalLeadsCount = dialerCampaignLeads?.totalLeads || 0;
    const contactedLeadsCount = dialerCampaignDetails?.contactedLeadsCount || 0;
    const progressPercent = totalLeadsCount > 0 ? Math.floor((contactedLeadsCount / totalLeadsCount) * 100) : 0;

    let dialerCampaignInactive = false;
    if (dialerCampaignDetails?.status) {
      dialerCampaignInactive = dialerCampaignDetails.status === "CANCELLED";
      isActive = dialerCampaignDetails.status === MarketingCampaignStatuses.NEW || dialerCampaignDetails.status === MarketingCampaignStatuses.PROCESSING;;
    } else if (campaign.get("campaigns")) {
      const dialerCampaign = campaign.get("campaigns").toJS().find((item) => item.id == this.state.dialerCampaignId);
      dialerCampaignInactive = dialerCampaign?.status === "CANCELLED";
      isActive = dialerCampaign?.status && (dialerCampaign?.status === MarketingCampaignStatuses.NEW || dialerCampaign?.status === MarketingCampaignStatuses.PROCESSING);
    }

    const btnProps = { loading };

    const currentLeadIndexOutOfTotalForDisplay = (dialerCampaignLeads?.page - 1) * this.props.leadsTableLimit + (currentLeadIndex + 1);

    if (checkingSkipTrace || isSkipTraced === null) {
      return (
        <div className={css.dialer}>
          <div className={classNames(css2.header, css.header)}>
            <div className={css2.left}>
              <div>
                <div className={css.title}>
                  {campaignName}
                  <SVG
                    icon="iconEditCampaign"
                    className={css.editIcon}
                    onClick={this.handleSettingsClick}
                  />
                </div>
                <div className={css.name}>
                  Dialer - {isActive ? (
                    <span className={css.statusActive}>Active</span>
                  ) : (
                    <span className={css.statusInactive}>Inactive</span>
                  )}
                </div>
              </div>
            </div>
            <div className={css2.right}>
              <Button {...btnProps} className={css.closeButton} onClick={this.handleClose}>Close</Button>
            </div>
          </div>
          <div className={classNames(css2.content, css.body)}>
            <Loader loaderDirection="minHorizontal" />
          </div>
        </div>
      );
    }



    const STATUS_OPTIONS = propertyStatuses;

    const moreFilesLink = this.state.id
      ? `/campaign/${marketingCampaignId}/dialer/${dialerCampaignId}/property-details/${this.state.id}#documents-reports`
      : null;

    const dialercampaignName = this.state.displayName || this.props.dialerCampaignDetails?.name || 'New Dialer Campaign';

    // Show skip trace panel at top if ALL contacts are non-skip-traced (none are skip traced)
    const allNonSkipTraced = nonSkipTracedContacts.length > 0 &&
      contactIdsArray.length > 0 &&
      nonSkipTracedContacts.length === contactIdsArray.length;
    const showTopSkipTracePanel = allNonSkipTraced;

    const hasLeadsInResponse =
      totalLeadsCount > 0 ||
      Boolean(dialerCampaignLeads?.leads && dialerCampaignLeads.leads.length > 0);
    const hasContacts = contactIdsArray.length > 0 || hasLeadsInResponse;

    const shouldShowTabs = hasContacts && !allNonSkipTraced;

    const hasProperty =
      property &&
      property.get('id') === this.state.currentPropertyId;
    // ATAI-520: CurrentLeadPreview swaps in the investor card for Investor Outreach leads.
    const currentLead = dialerCampaignLeads?.leads?.[currentLeadIndex];
    const logs = property.getIn(['status', 'logs'], List());
    const lastNoteLog = logs
      .map(log => this.parseLog(log))
      .find(({ event }) => /^Note (Added|Changed|Removed)$/i.test(event));

    const lastUpdated = lastNoteLog ? lastNoteLog.date : null;
    const searchType = null;
    const callCount = this.props.callCountForToday || 0;
    return (
      <div className={css.dialer}>
        <div className={classNames(css2.header, css.header)}>
          <div className={css2.left}>
            <div>
              <div className={css.title}>
                <span title={dialercampaignName} className={css.campaignName}>{dialercampaignName}</span>
                <SVG
                  icon="iconEditCampaign"
                  className={css.editIcon}
                  onClick={this.handleSettingsClick}
                />
              </div>
              <div className={css.name}>
                Dialer - {isActive ? (
                  <span className={css.statusActive}>Active</span>
                ) : (
                  <span className={css.statusInactive}>Inactive</span>
                )}
              </div>
            </div>
          </div>
          <div className={css.right}>
            {isActive && (
              <>
                <Button {...btnProps} className={css.closeButton} onClick={this.handleClose}>Close</Button>
                <div className={css.callProgressWrapper}>
                  <Button {...btnProps}
                    className={classNames(css.callProgressButton, { [css.active]: this.state.showCallProgress })}
                    onClick={this.handleCallProgressClick}
                    loading={this.props.callCountForTodayLoading}
                  >
                    Call Progress:<span className={callCount >= MAX_DAILY_CALLS ? css.maxReachedText : ""}>&nbsp;{callCount}/{MAX_DAILY_CALLS}</span>
                  </Button>

                  {this.state.showCallProgress && (
                    <div ref={(el) => (this.popupRef = el)} className={css.callProgressPopover} onClick={(e) => e.stopPropagation()}>
                      <CallProgress callCountForToday={this.props.callCountForToday} maxCalls={MAX_DAILY_CALLS} />
                    </div>
                  )}
                </div>
                <Button {...btnProps} className={css.endCampaignButton} onClick={this.handleEndCampaignClick} loading={isEndingCampaign}>End Activity</Button>
                <Button {...btnProps} className={css.headerButton} onClick={this.handleDownloadClick} loading={isDownloading}>Download</Button>
                <Button {...btnProps} className={css.headerButton} onClick={this.handleDuplicateClick} loading={this.state.isDuplicating}>Duplicate</Button>
                <SolidButton className={css.editLeadsButton} onClick={this.handleEditLeadsClick} loading={this.state.isLoadingContactIds}>Edit Leads ({totalLeadsCount})</SolidButton>
              </>
            )}
            {/*inactive campaigns have different button positions, end campaign button is hidden, Edit leads button is disabled and
             Duplicate button is solid*/}
            {dialerCampaignInactive && (
              <>
                <Button {...btnProps} className={css.closeButton} onClick={this.handleClose}>Close</Button>
                <Button {...btnProps} className={css.headerButton} onClick={this.handleDownloadClick} loading={isDownloading}>Download</Button>
                <Button {...btnProps} className={css.headerButton} onClick={this.handleEditLeadsClick}>View Leads ({totalLeadsCount})</Button>
                <SolidButton className={css.editLeadsButton} onClick={this.handleDuplicateClick} loading={this.state.isDuplicating}>Duplicate</SolidButton>
              </>
            )
            }
          </div>
        </div>
        <div className={classNames(css2.content, css.body)}>
          {/* {this.state.showCallProgress && (
            <div
              ref={(el) => (this.popupRef = el)}
              className={css.callProgressPopover}
              onClick={(e) => e.stopPropagation()}
            >
              <CallProgress
                callCountForToday={this.props.callCountForToday}
                maxCalls={MAX_DAILY_CALLS}
              />
            </div>
          )} */}
          {(showTopSkipTracePanel && !dialerCampaignInactive) && (
            <div className={css.skipTraceSection}>
              <SkipTracePanel contactIds={contactIdsArray} />
            </div>
          )}

          {isActive && shouldShowTabs ? (
            <Tabs selectedIndex={selectedTabIndex} onSelect={this.handleTabSelect} className={css.tabs}>
              <div className={css.tabsHeader}>
                <TabList className={css.tabList}>
                  <Tab className={css.tab} selectedClassName={css.tabSelected}>
                    Current Leads
                  </Tab>
                  <Tab className={css.tab} selectedClassName={css.tabSelected}>
                    Campaign Details
                  </Tab>
                </TabList>
                {selectedTabIndex === 0 && (
                  <div className={css.navigation}>
                    {/* X of Y Leads counter — positioned left of Previous per PRD */}
                    {dialerCampaignLeads?.totalLeads && (
                      <span className={css.leadCounter}>
                        {currentLeadIndexOutOfTotalForDisplay} of {dialerCampaignLeads.totalLeads} Leads
                      </span>
                    )}

                    <Button {...btnProps} className={css.navButton} onClick={this.handlePreviousContact}
                      disabled={!this.props.dialerCampaignLeads || !this.props.dialerCampaignLeads.leads || this.props.dialerCampaignLeads.leads.length == 0
                        || (this.props.dialerCampaignLeads.page == 1 && this.state.currentLeadIndex == 0)}>
                      <SVG icon="iconArrowLeft" size={18} className={css.navIconLeft} />
                      <span>Previous</span>
                    </Button>

                    <Button {...btnProps} className={classNames(css.navButton, css.navButtonNext)} onClick={this.handleNextContact}
                      disabled={!this.props.dialerCampaignLeads || !this.props.dialerCampaignLeads.leads || this.props.dialerCampaignLeads.leads.length == 0
                        || (this.props.dialerCampaignLeads.page == this.props.dialerCampaignLeads.totalPages && this.state.currentLeadIndex + 1 == this.props.dialerCampaignLeads.leads.length)}>
                      <span>Next</span>
                      <SVG icon="iconArrowRight" size={18} className={css.navIconRight} />
                    </Button>
                  </div>
                )}
                {selectedTabIndex === 1 && nonSkipTracedContacts.length > 0 && (
                  <div className={css.campaignDetailsHeaderActions}>
                    {isActive && <Button {...btnProps} className={css.skipTraceButtonHeader} onClick={this.handleSkipTraceClick}>
                      <SVG icon="iconSkipTrace" size={20} />
                      <span>Skip Trace</span>
                    </Button>}
                    {headerStartSkipTrace && (
                      <SkipTraceHandler
                        contactIds={headerSkipTraceContactIds}
                        startSkipTrace={headerStartSkipTrace}
                        onProcessed={this.handleHeaderSkipTraceComplete}
                      />
                    )}
                  </div>
                )}
              </div>
              <TabPanel className={css.tabPanel}>
                <div className={css.currentLeads}>
                  {/* Main Content Area */}
                  <div className={css.leadsContent}>
                    {/* Contact and Property Cards Row */}
                    <div className={css.cardsRow}>
                      {/* Contact Card (Upper Left) */}
                      <CurrentLeadContactCard
                        dialerCampaignId={dialerCampaignId}
                        marketingCampaignId={marketingCampaignId}
                        accountId={this.props.userProfile?.get('userId')}
                        lead={this.props.dialerCampaignLeads?.leads?.length ? this.props.dialerCampaignLeads.leads[this.state.currentLeadIndex] : null}
                      />
                      {/* Property Preview Card (Upper Right) */}
                      {/* <div className={css.propertyCard}> */}
                      {/* ?<div className={css.cardTitle}>Property</div> */}

                      <CurrentLeadPreview key={currentLead?.contactInfo?.id} lead={currentLead} history={history}>
                      {hasProperty ? (
                        <PropertyInfo
                          info={property}
                          property={property}
                          history={history}
                          loading={propertyLoading || isLoadingProperty}
                          getProperty={this.props.getProperty}
                          saveEnabled={false}
                          nearbySearchEnabled={false}
                          photoGalleryEnabled={false}
                          closeButtonEnabled={false}
                          hoverEffectsEnabled={false}
                          cardStyle="compact"
                          searchType={searchType}
                        />
                      ) : (
                        <div className={css.placeholder}>
                          {isLoadingProperty ? (
                            <Loader loaderSize="small" />
                          ) : (
                            'Property preview card placeholder'
                          )}
                        </div>
                      )}
                      </CurrentLeadPreview>
                      {/* </div> */}
                    </div>
                    <ClickToDial profile={this.props.profile} />
                    {/* Status, Tags, and Notes Panel (Lower Section) */}
                    <div className={css.statusTagsNotes}>
                      {this.state.isSavingNotesCard && (
                        <div className={css.cardLoader}>
                          <Loader loaderSize="small" />
                        </div>
                      )}
                      <div className={css.statusTagsRow}>
                        <div className={css.field}>
                          <label className={css.label}>Property Status</label>

                          <Select
                            lists={STATUS_OPTIONS}
                            placeholder="Property Status"
                            selectedValue={this.state.selectedStatus}
                            onSelect={this.handleStatusSelect}
                          />
                        </div>

                        <div className={css.field}>
                          <div className={css.fieldHeader}>
                            <label className={css.label}>Property Tags</label>
                            <span
                              className={css.subLabel}
                              onClick={this.openMangePropertyTagModal}
                            >
                              Manage Tags
                            </span>
                          </div>
                          <MultiSelect
                            lists={propertyTags}
                            placeholder="Property Tags"
                            selectedValues={this.state.selectedTags}
                            onSelect={this.handleTagsSelect}
                          />
                        </div>
                      </div>

                      <div>
                        <CommonNotes
                          value={this.state.notes}
                          attachments={this.state.attachments}
                          onChange={this.handleNotesChange}
                          onUpload={this.handleFileUpload}
                          onRemoveAttachment={this.handleRemoveAttachment}
                          onSave={() => this.handleSave(false, "notes")}
                          notesDirty={this.props.notesDirty}
                          onDownloadAttachment={this.handleDownloadAttachment}
                          moreFilesLink={moreFilesLink}
                          isSaving={this.state.isSavingNotesCard}
                          lastUpdated={lastUpdated}
                        />

                        <ToastNotification
                          message={this.state.toastMessage}
                          show={this.state.showToast}
                          type={this.state.toastType}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </TabPanel>
              <TabPanel className={css.tabPanel}>
                <CampaignDetails
                  contactedLeadsCount={contactedLeadsCount}
                  totalLeadsCount={totalLeadsCount}
                  progressPercent={progressPercent}
                  status={status}
                  dialerCampaignLeads={this.props.dialerCampaignLeads}
                  dialerCampaignInactive={dialerCampaignInactive}
                  onLeadsTableScroll={this.onLeadsTableScroll}
                  getAddressText={this.getAddressText}
                  formatPhoneNumber={this.formatPhoneNumber}
                  currentLeadIndex={this.state.currentLeadIndex}
                  onLeadClick={(index) => {
                    this.handleTabSelect(0);
                    this.setState({ currentLeadIndex: index });
                    const currentPropertyId = this.props.dialerCampaignLeads.leads[index].propertyInfo?.propertyId;
                    const currentSavedPropertyId = this.props.dialerCampaignLeads.leads[index].propertyInfo?.savedPropertyId;

                    this.setState({ currentPropertyId, currentSavedPropertyId });
                  }}
                />
              </TabPanel>
            </Tabs>
          ) : (allNonSkipTraced || dialerCampaignInactive) && (
            // When ALL contacts are not skip-traced, show Campaign Details table below skip trace panel
            <CampaignDetails
              contactedLeadsCount={contactedLeadsCount}
              totalLeadsCount={totalLeadsCount}
              progressPercent={progressPercent}
              status={status}
              dialerCampaignLeads={this.props.dialerCampaignLeads}
              dialerCampaignInactive={dialerCampaignInactive}
              onLeadsTableScroll={this.onLeadsTableScroll}
              getAddressText={this.getAddressText}
              formatPhoneNumber={this.formatPhoneNumber}
              leadsTableRef={this.leadsTableRef}
              allNonSkipTraced={allNonSkipTraced}
            />
          )}
        </div>

        <EndDialerCampaignConfirmationModal
          open={showEndCampaignModal}
          onCancel={this.handleCloseEndCampaignModal}
          onConfirm={this.handleEndCampaignConfirmation}
          disable={isEndingCampaign} />

        {this.props.children}
        <div className={cssModal.clsIntegrationCard}>
          <NotesNotSaved
            isOpen={this.state.showNotesModal}
            onClose={this.handleCancelNavigation}
            onConfirm={this.handleConfirmNavigation}
          />

          <Prompt
            when={this.props.notesDirty}
            message={(location) => {
              this.setState({
                showNotesModal: true,
                nextLocation: location,
              });
              return false;
            }}
          />
        </div>
        {
          this.state.showRenameModal && (
            <div className={css2.modalOverlay} onClick={this.handleCancelName}>
              <div className={css2.modalContainer} onClick={(e) => e.stopPropagation()}>
                <h2 className={css2.modalTitle}>Dialer Campaign Name</h2>

                <input
                  type="text"
                  autoComplete="off"
                  className={css2.modalInput}
                  value={this.state.editName}
                  onChange={this.handleNameChange}
                />

                <div className={css2.modalActions}>
                  <Button
                    className={css2.cancelButton}
                    onClick={this.handleCancelName}
                  >
                    Cancel
                  </Button>

                  <Button
                    className={css2.saveButton}
                    onClick={this.handleSaveName}
                    disabled={!this.state.editName || !this.state.editName.trim()}
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          )
        }
        <ConfirmationModal
          isOpen={this.state.showRemoveModal}
          onClose={this.handleCancelRemove}
          title="Remove Document?"
          message={
            <>
              Are you sure you want to remove this document?
              <br />
              It will also be removed from the Documents &amp; Reports section.
            </>
          }
          confirmLabel="Remove"
          cancelLabel="Cancel"
          onConfirm={this.handleConfirmRemove}
          isDanger
        />
      </div>
    );
  }
}

export default withRouter(connect(state => ({
  campaign: selectCampaign(state),
  loading: selectLoading(state),
  dialerCampaignDetails: selectDialerCampaignDetails(state),
  dialerCampaignLeads: selectDialerCampaignLeads(state),
  leadsTableLimit: 500,
  propertyTags: selectTags(state).toJS(),
  notesDirty: selectNotesDirty(state),
  propertyStatuses: selectStatuses(state).toJS(),
  propertyStatus: selectPropertyStatus(state),
  documents: selectDocuments(state),
  userProfile: selectUserProfile(state),
  profile: selectProfile(state),
  property: state.getIn(['property', 'property']) || state.getIn(['property', 'data'], Map()),
  propertyLoading: state.getIn(['property', 'loading'], false),
  callCountForToday: selectCallCountForToday(state),
  callCountForTodayLoading: selectCallCountForTodayLoading(state),
}), {
  loadDialerCampaignDetails,
  checkSkipTraced,
  checkSkipTracedGroup,
  downloadDialerCampaignReport,
  endDialerCampaign,
  loadDialerCampaignLeads,
  updateDialerCampaign,
  duplicateDialerCampaign,
  getProperty,
  getPropertyStatus,
  getPropertyContact,
  getContactIds,
  getCallCountForToday,
  setNotesDirty,
  savePropertyStatus,
  resetNotesDirty,
  uploadPropertyDocument,
  loadPropertyDocuments,
  downloadPropertyDocument,
  openContactAssignmentPopup: ContactAssignmentPopup.open,
  deletePropertyDocument,
  confirm: Confirm.open,
  MangePropertyTagModalOpen: MangePropertyTagModal?.open,
  showAlert: InfoAlert.open,

})(DialerCampaign));